<template>
    <transition name="fade" mode="out-in">

        <article v-if="legit && show" class="project type-project status-publish hentry">

            <header v-if="page" class="entry-header bg-parent" :style="{ backgroundColor: page.header_background, color: page.header_colour}">

                <div class="bg-fade" v-lazy:background-image="'https://api.alt-design.net/api/image/' + page.header_image[0]" ></div>

                <p class="sectors">{{ page.sub_title }}</p>

                <h1 class="entry-title">{{ page.title }}</h1>

            </header><!-- .entry-header -->

            <div class="entry-content">

                <page-builder :content="content" v-if="content"></page-builder>

                <nav class="animateIn navigation" role="navigation" v-if="pagination">
                    <div class="nav-next">
                        <router-link :to="'/work/' + pagination.previous.slug" title="View Previous Project">
                            <h2 class="name">{{ pagination.previous.title }}</h2>
                            <p class="tag">{{ pagination.previous.sub_title }}</p>
                            <p class="button">Previous</p>
                        </router-link>
                    </div>

                    <div class="nav-previous">
                        <router-link :to="'/work/' + pagination.next.slug" title="View next Project">
                            <h2 class="name">{{ pagination.next.title }}</h2>
                            <p class="tag">{{ pagination.next.sub_title }}</p>
                            <p class="button">Next</p>
                        </router-link>
                    </div>
                </nav><!-- .navigation -->

                <div class="social-buttons animateIn">
                    <ul>
                        <h2 class="title">Follow us!</h2>
                        <li class="facebook"><a href="https://www.facebook.com/altdesignderby/" target="_blank" title="Find us on Facebook"><span class="icon-facebook"></span></a></li>
                        <li class="twitter"><a href="https://twitter.com/_altdesign" target="_blank" title="Follow us on Twitter"><span class="icon-twitter"></span></a></li>
                        <li class="instagram"><a href="https://www.instagram.com/_altdesign/" target="_blank" title="Follow us on Instagram"><span class="icon-instagram"></span></a></li>
                    </ul>
                </div>

            </div><!-- .entry-content -->

        </article><!-- .project -->

        <loading v-else-if="legit"></loading>

        <missing v-else></missing>

    </transition>

</template>

<script>
  import missing from '../404.vue'

  export default {
    data () {
      return {
        legit: true,
        page: '',
        content: '',
        pagination: '',
        show: false,
        sectors: []
      }
    },
    created () {
      window.api.get('get-pages/' + this.$route.params.project).then(res => {
        if (res.data.res === false) {
          this.legit = false
          return
        }
        this.page = res.data.data.page
        if (this.page.header_image[0]) {
          document.querySelector('meta[property="og:image"]').content = 'https://api.alt-design.net/api/image/' + this.page.header_image[0]
        }

        // Check and set SEO
        if (this.page.seo_title && this.page.seo_title.length > 0 && this.page.seo_description.length > 0) {
          this.$setSeo(this.page.seo_title, this.page.seo_description)
        } else {
          this.$setSeo(this.page.title + ' - Alt Design - Graphic Design and Web Development in Derby', 'Based in Derby, Alt Design are one of the top graphic design agencies in the Midlands specialising in branding, print, and web design. Call us on 01332 208733.')
        }
        this.content = res.data.data.content
        this.pagination = res.data.data.pagination
        this.$store.commit('setCurrentSectors', this.page.sectors)
      }).then(() => {
        this.show = true
        this.$nextTick(() => {
          this.$setTweens()
        })
      })
    },
    components: {
      missing: missing
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Pages/Projects/Project.vue